import * as amplitude from "@amplitude/analytics-browser"
import { isSsr } from "libs/utils/logic/isServer"

const getEnvironment = () => {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    return "dev"
  } else {
    return "prod"
  }
}

interface UseAnalyticsReturn {
  track: (eventName: string, props?: Record<string, string>) => void
}

export const useAnalytics = (): UseAnalyticsReturn => {
  const track = (eventName: string, props?: Record<string, string>) => {
    if (isSsr()) {
      return
    }

    amplitude.track(eventName, {
      ...props,
      hostname: window.location?.hostname,
      path: window.location?.pathname,
      environment: getEnvironment(),
    })
  }

  return {
    track,
  }

  return {
    track,
  }
}
